// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiesPolicy_container__1KeBZ","heading":"CookiesPolicy_heading__UhEFj"};